const genControlHeight = token => {
  const {
    controlHeight
  } = token;
  return {
    controlHeightSM: controlHeight * 0.75,
    controlHeightXS: controlHeight * 0.5,
    controlHeightLG: controlHeight * 1.25
  };
};
export default genControlHeight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/themes/shared/genControlHeight.js
// module id = 968
// module chunks = 0